module.exports = __webpack_public_path__ + "img/failure.cb9f6415.svg";